import React from 'react'
import injectSheet from 'react-jss'
import Button from 'react-validation/build/button'
import Form from 'react-validation/build/form'
import Input from 'react-validation/build/input'
import Textarea from 'react-validation/build/textarea'
import { FormInputContainer, TitleContainer } from '../../'
import { validEmail, validPostal, isRequired } from '../../../utils/validations'

class OfferForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { ...props.prefill }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.removeError = this.removeError.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(event) {
    event.preventDefault()
    this.props.setClient(this.state)
  }

  handleInputChange(event) {
    const { target } = event
    const value = target.type === 'checkbox' ? target.checked : target.value
    const { name } = target

    this.setState({
      [name]: value,
    })
    this.props.setPrefill({ ...this.state, [name]: value })
  }

  removeError() {
    this.form.hideError(this.userInput)
  }

  render() {
    const {
      classes,
      form: { intro, submitButton },
    } = this.props

    const {
      email,
      firstName,
      lastName,
      location,
      message,
      phone,
      street,
      streetNumber,
      zip,
    } = this.state

    return (
      <TitleContainer title="Angebot anfordern">
        <div>
          <div className={`${classes.container}`}>
            <div className={`${classes.intro}`}>{intro}</div>
            <Form
              className={`${classes.formContainer}`}
              ref={(c) => {
                this.form = c
              }}
              onSubmit={this.handleSubmit}
            >
              <div className={`${classes.inputContainer}`}>
                <FormInputContainer
                  width={50}
                  label="Vorname*"
                  forHtml="firstName"
                  filled={firstName}
                >
                  <Input
                    id="firstName"
                    onFocus={this.removeError}
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="text"
                    value={firstName}
                    name="firstName"
                    validations={[isRequired]}
                  />
                </FormInputContainer>
                <FormInputContainer
                  width={50}
                  label="Nachname*"
                  forHtml="lastName"
                  filled={lastName}
                >
                  <Input
                    id="lastName"
                    onFocus={this.removeError}
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="text"
                    value={lastName}
                    name="lastName"
                    validations={[isRequired]}
                  />
                </FormInputContainer>
                <FormInputContainer
                  width={75}
                  label="Adresse*"
                  forHtml="street"
                  filled={street}
                >
                  <Input
                    id="street"
                    onFocus={this.removeError}
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="text"
                    value={street}
                    name="street"
                    validations={[isRequired]}
                  />
                </FormInputContainer>
                <FormInputContainer
                  width={25}
                  label="Nr.*"
                  forHtml="streetNumber"
                  filled={streetNumber}
                >
                  <Input
                    id="streetNumber"
                    onFocus={this.removeError}
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="text"
                    value={streetNumber}
                    name="streetNumber"
                    validations={[isRequired]}
                  />
                </FormInputContainer>
                <FormInputContainer
                  width={25}
                  label="PLZ*"
                  forHtml="zip"
                  filled={zip}
                >
                  <Input
                    id="zip"
                    onFocus={this.removeError}
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="number"
                    value={zip}
                    name="zip"
                    validations={[isRequired, validPostal]}
                  />
                </FormInputContainer>
                <FormInputContainer
                  width={75}
                  label="Ort*"
                  forHtml="location"
                  filled={location}
                >
                  <Input
                    id="location"
                    onFocus={this.removeError}
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="text"
                    value={location}
                    name="location"
                    validations={[isRequired]}
                  />
                </FormInputContainer>
              </div>
              <div className={`${classes.inputContainer}`}>
                <FormInputContainer
                  label="Email*"
                  forHtml="email"
                  filled={email}
                >
                  <Input
                    id="email"
                    onFocus={this.removeError}
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="email"
                    value={email}
                    name="email"
                    validations={[isRequired, validEmail]}
                  />
                </FormInputContainer>
                <FormInputContainer
                  label="Telefon-Nummer*"
                  forHtml="phone"
                  filled={phone}
                >
                  <Input
                    id="phone"
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="tel"
                    value={phone}
                    name="phone"
                    validations={[isRequired]}
                  />
                </FormInputContainer>
                <FormInputContainer
                  label="Notizen"
                  forHtml="message"
                  filled={message}
                >
                  <Textarea
                    id="message"
                    onFocus={this.removeError}
                    onChange={this.handleInputChange}
                    ref={(c) => {
                      this.userInput = c
                    }}
                    type="text"
                    value={message}
                    name="message"
                  />
                </FormInputContainer>
              </div>
              <div className={`${classes.inputContainer} submit`}>
                <FormInputContainer>
                  <Button>{submitButton}</Button>
                </FormInputContainer>
              </div>
            </Form>
          </div>
        </div>
      </TitleContainer>
    )
  }
}

const styles = theme => ({
  container: {
    margin: `0px ${theme.sizes.gutter / 2}px`,
    padding: `${theme.sizes.gutter}px ${theme.sizes.gutter / 2}px`,
    backgroundColor: theme.colors.main_2,
    color: theme.colors.secondary_3b,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  intro: {
    width: '100%',
    textAlign: 'center',
  },
  formContainer: {
    width: '100%',
    maxWidth: '400px',
    height: '100%',
  },
  inputContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: `${theme.sizes.gutter}px`,
    '&.submit': {
      textAlign: 'right',
      paddingTop: 0,
    },
  },
})

export default injectSheet(styles)(OfferForm)



// WEBPACK FOOTER //
// ./src/modules/offer/components/offerForm.jsx